module.exports = __webpack_public_path__ + "media/images/icons/new-tab-icon-e93be3cf4d3af84fcbeb1e5dcf81accd.svg";